import { useHorizontalLineStyles } from './HorizontalLine.styles';
import { IHorizontalLineProps } from './HorizontalLine.types';
import { mergeClasses } from '@fluentui/react-components';

const HorizontalLine = (props: IHorizontalLineProps) => {
    const styles = useHorizontalLineStyles();

    return <hr className={mergeClasses(styles.lineBreak, props.className)} />;
};

export default HorizontalLine;
